import { render, staticRenderFns } from "./BaseRadioGroup.vue?vue&type=template&id=0d2d0f69&"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports